<div class="custom-dialog">
    <mat-dialog-content>
        <div *ngIf="loading" class="loading">
            <mat-spinner diameter="40"></mat-spinner>
            <p>Loading care plan...</p>
        </div>

        <div *ngIf="error" class="error">
            <mat-icon color="warn">error</mat-icon>
            <p>{{ error }}</p>
        </div>

        <div *ngIf="carePlan && !loading && !error" class="dialog-content">
            <div class="header-section">
                <div class="dialog-header">
                    <div class="photo-container" *ngIf="!loadingPhoto">
                        <img *ngIf="profilePhotoUrl" [src]="profilePhotoUrl" alt="Client photo" class="photo">
                        <mat-icon *ngIf="!profilePhotoUrl" class="placeholder-icon">account_circle</mat-icon>
                    </div>
                    <h3>{{ carePlan.headerDetails.Client }}</h3>
                </div>
                <div class="details-section">
                    <p><strong>{{ carePlan.headerDetails.PlanIsActive === '1' ? 'Active' : 'Inactive' }} Care
                            Plan</strong> v{{ carePlan.headerDetails.Version }}: {{ carePlan.headerDetails.StartDate |
                        date }} to {{ carePlan.headerDetails.EndDate | date }}</p>
                </div>
            </div>

            <div class="services-section" *ngIf="selectedService">
                <h4><span class="title-text">{{ initialStartTime }}</span> - {{ selectedService.Description }}</h4>
                <p class="service-details">{{ selectedService.DescriptionSchedule }} Care Plan Item {{
                    selectedService.ID }}</p>

                <div class="content-window-l1" *ngIf="rateWindow || rateWindowError">
                    <!-- Two-person assist section - only show for 2PA events with multiple carers -->
                    <div *ngIf="is2pa && hasMultipleCarers" class="content-window-l2 two-pa-section">
                        <h5>Two-Person Assist</h5>
                        <p class="service-details">This service requires two staff members. You can remove one staff member if needed.</p>

                        <div class="allocated-carers-list">
                            <div *ngFor="let carer of allocatedCarers" class="allocated-carer-item">
                                <span class="carer-name">{{ carer.name }}</span>
                                <button mat-icon-button color="warn" (click)="removeCarer(carer.id)"
                                        [disabled]="allocatedCarers.length <= 1"
                                        matTooltip="Remove this carer">
                                    <mat-icon>remove_circle</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>

                    <h5>Adjust Care Plan</h5>

                    <!-- Care-plan editing (key staff + permanent service time) DISABLED (eCase #6542,
                         2026-09): these drive eCase's updateServicePlanDetails endpoint, which creates
                         duplicate group-activity records and blocks plan deactivation / movement-out.
                         Make care-plan changes directly in eCase. Temporary changes (timeline
                         drag-reschedule, carer allocation) are unaffected. -->
                    <div class="content-window-l2">
                        <div class="careplan-disabled-notice">
                            <mat-icon>info</mat-icon>
                            <div class="notice-content">
                                <strong>Care plan changes are disabled here.</strong>
                                <p>Changing key staff or permanently changing a service time through this
                                   app creates data-integrity issues in eCase. These changes must be made
                                   directly in eCase.</p>
                                <p>Temporary changes on the timeline (moving a single appointment or
                                   allocating staff) are not affected.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-raised-button (click)="pendingChanges ? applyChanges() : onClose()">
            {{ pendingChanges ? 'Apply' : 'Close' }}
        </button>
    </mat-dialog-actions>
</div>
